import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues, getListItems } from 'tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
import TreeSelect from 'tyan/business/TreeSelect'
import { exportFile } from 'tyan/public/index'

class AssetChangeDiv extends React.Component {
	state = {
	}

	componentDidMount = () => {
		const { id } = this.props
		this.handlerInitValues(id)
	}

	handlerInitValues = (id) => {
		const { taskName } = this.props
		Tyan.doPostEvent({
			event: 'GetAssetChange',
			data: { id, taskName },
			onEnd: ({ errorMessage, initValues基本信息, 部门, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, 部门, optionsParas })
				}
			}
		})
	}

	handlerSave = () => {
		const { advanceExpenseID } = this.props
		const { id, changedValues基本信息 } = this.state
		Tyan.doPostEvent({
			event: 'SaveAssetChange',
			data: { id, advanceExpenseID, changedValues基本信息 },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					this.handlerInitValues(id)
				}
			}
		})
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onSave, onClose } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteAssetChange',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			}))
	}

	handlerAssetChangePrint = () => {
		const { id } = this.state
		exportFile(null, null, "AssetChangePrint?id=" + id)
	}

	handlerAddInfo = () => {
		let 申请人 = getFormValue(this, '基本信息', '申请人')
		addListItem(this, { 移出部门资产保管人: 申请人 }, '基本信息', '资产异动明细')
	}

	handlerDeleteInfo = (id) => {
		deleteListItem(this, '基本信息', '资产异动明细', id)
	}

	handleShowDiv = (initValues, onConfirm, onDelete) => {
		Tyan.pubForm.showDialog(initValues.title, props => <TreeSelect {...props} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} />)
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	canSave = () => {
		var bSave = false
		const 状态 = getFormValue(this, '基本信息', '状态')
		const 异动结果附件 = getFormValue(this, '基本信息', '异动结果附件')
		const 异动原因 = getFormValue(this, '基本信息', '异动原因')
		const { list } = getListItems(this, '基本信息', '资产异动明细')
		//console.log('list',list)
		//console.log('list',list.filter(o => o.入账日期 == nullDate).length)

		if (异动原因 == '部门变更') {
			bSave = list && list.length > 0 && list.filter(o => !o.移入部门资产保管人).length == 0
		}
		else {
			bSave = list && list.length > 0 && list.filter(o => !o.现资产保管人).length == 0
		}
		if (状态 == '财务经办签核') {
			bSave = list && list.length > 0 && (list.filter(o => !o.资产残值).length == 0 ||
				list.filter(o => o.资产残值 < 0).length == 0) &&
				list.filter(o => o.入账日期 == nullDate).length == 0 &&
				(list.filter(o => !o.资产原值).length == 0 ||
					list.filter(o => o.资产原值 < 0).length == 0)
		}
		if (状态 == '资产异动') {
			bSave = 异动结果附件 && 异动结果附件.length > 0
		}

		return getFormValue(this, '基本信息', '资产性质') &&
			getFormValue(this, '基本信息', '异动原因') &&
			getFormValue(this, '基本信息', '移出部门') &&
			getFormValue(this, '基本信息', '移入部门') &&
			getFormValue(this, '基本信息', '事由') &&
			list && list.length > 0 && list.filter(o => !o.资产编码).length == 0 &&
			list && list.length > 0 && list.filter(o => !o.资产名称).length == 0 &&
			list && list.length > 0 && list.filter(o => !o.数量).length == 0 &&
			list && list.length > 0 && list.filter(o => !o.附属设备).length == 0 &&
			list && list.length > 0 && list.filter(o => !o.存放地点).length == 0 &&
			list && list.length > 0 && list.filter(o => !o.现存放地点).length == 0 &&
			list && list.length > 0 && list.filter(o => !o.移出部门资产保管人).length == 0 && bSave
	}

	fieldset基本信息 = () => {
		const { readOnly } = this.props
		const { 部门 } = this.state
		const { list } = getListItems(this, '基本信息', '资产异动明细')
		const treeName = getFormValue(this, '基本信息', 'treeName')
		const treeField = getFormValue(this, '基本信息', 'treeField')
		const p = { margin: '5px 5px 5px 5px', minWidth: 1, _full: true, flex: 1, clearable: false }
		const 状态 = getFormValue(this, '基本信息', '状态')
		const 异动原因 = getFormValue(this, '基本信息', '异动原因')
		return [
			{ _text: '申请编号', minWidth: '45%', disabled: true },
			{ _text: '申请人', minWidth: '45%', disabled: true },
			{ _date: '申请时间', minWidth: '45%', disabled: true },
			{ _text: '申请部门', minWidth: '45%', disabled: true },
			{ _radio: '资产性质', minWidth: '45%', required: true },
			{ _select: '异动原因', minWidth: '45%', required: true },
			{
				_text: '移出部门', name: '移出部门', minWidth: '45%', disabled: true, required: true,
				button: {
					text: "...",
					disabled: readOnly || 状态 !== '申请中',
					handler: () => this.handleShowDiv(
						{ title: '部门', ...部门, treeName: treeName, treeField: treeField },
						(changedValues) => changeItemsValue(this, '基本信息', ['移出部门ID', '移出部门'], [changedValues['fatherID'], changedValues['fullName']]),
					)
				}
			},
			{
				_text: '移入部门', name: '移入部门', minWidth: '45%', disabled: true, required: true,
				button: {
					text: "...",
					disabled: readOnly || 状态 !== '申请中',
					handler: () => this.handleShowDiv(
						{ title: '部门', ...部门, treeName: treeName, treeField: treeField },
						(changedValues) => changeItemsValue(this, '基本信息', ['移入部门ID', '移入部门'], [changedValues['fatherID'], changedValues['fullName']]),
					)
				}
			},
			{ _text: '事由', minWidth: '95%', maxRows: 3, required: true },
			{ _files: '附件', minWidth: '95%' },
			{
				_border: `资产异动明细`, name: `资产异动明细`, minWidth: '90%', items: [
					{
						_group: ``, minWidth: '95%', items: [
							{ _label: `资产编码<span style='color:red;'>*</span>`, ...p, flex: 2, },
							{ _label: `资产名称<span style='color:red;'>*</span>`, ...p, flex: 2, },
							//{ _label: '规格型号', ...p, },
							{ _label: `数量<span style='color:red;'>*</span>`, ...p, flex: 1, },
							{ _label: `附属设备<span style='color:red;'>*</span>`, ...p, flex: 2, },
							{ _label: `原存放地点<span style='color:red;'>*</span>`, ...p, flex: 2, },
							{ _label: `现存放地点<span style='color:red;'>*</span>`, ...p, flex: 2, },
							{ _label: 异动原因 == '部门变更' ? `移出部门资产保管人<span style='color:red;'>*</span>` : `原资产保管人<span style='color:red;'>*</span>`, ...p, flex: 3, },
						].concat(异动原因 == '部门变更' ? { _label: `移入部门资产保管人<span style='color:red;'>*</span>`, ...p, flex: 3, } : { _label: `现资产保管人<span style='color:red;'>*</span>`, ...p, flex: 2, }
						).concat({ _label: '备注', ...p, flex: 2 },
							{
								_buttons: [
									{ _button: '添加', icon: '', ui: '', margin: 0, hidden: readOnly || 状态 !== '申请中', handler: () => this.handlerAddInfo() }
								], width: '101px', margin: 0, flex: 2
							})
					},
				].concat(list && list.map(({ id }) => {
					const _list = { listName: '资产异动明细', id }
					return {
						_group: '', minWidth: '95%', list: _list, items: [
							{ _text: '', name: '资产编码', ...p, flex: 2 },
							{ _text: '', name: '资产名称', ...p, flex: 2 },
							//{ _text: '', name: '规格型号', ...p, },
							{ _text: '', name: '数量', ...p, flex: 1 },
							{ _text: '', name: '附属设备', ...p, flex: 2 },
							{ _select: '', name: '存放地点', ...p, editable: true, forceSelection: false, optionName: '存放地点', flex: 2 },
							{ _select: '', name: '现存放地点', ...p, editable: true, forceSelection: false, optionName: '存放地点', flex: 2 },
							{ _select: '', name: '移出部门资产保管人', ...p, editable: true, optionName: '资产保管人', flex: 3 },
						].concat(异动原因 == '部门变更' ? { _select: '', name: '移入部门资产保管人', ...p, editable: true, optionName: '资产保管人', flex: 3 } : { _select: '', name: '现资产保管人', ...p, editable: true, forceSelection: false, optionName: '资产保管人', flex: 2 }
						).concat({ _text: '', name: '备注', ...p, flex: 2 },
							{
								_buttons: [
									{
										_button: '删除', icon: 'trash-o', ui: 'decline', margin: 0, hidden: readOnly || 状态 !== '申请中',
										handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(id) }),
									}
								], width: '101px', margin: 0, flex: 2
							})
					}
				}))
			},
			{
				_border: `财务处理`, name: `财务处理`, minWidth: '90%', cdt: () => 状态 !== '申请中', disabled: 状态 !== '财务经办签核', items: [
					{
						_group: ``, minWidth: '95%', items: [
							{ _label: `资产编码<span style='color:red;'>*</span>`, ...p, },
							{ _label: `资产名称<span style='color:red;'>*</span>`, ...p, },
							{ _label: `资产原值<span style='color:red;'>*</span>`, ...p, },
							{ _label: `资产残值<span style='color:red;'>*</span>`, ...p, },
							{ _label: `入账日期<span style='color:red;'>*</span>`, ...p, },
							{ _label: '备注', ...p, },
						]
					}
				].concat(list && list.map(({ id }) => {
					const _list = { listName: '资产异动明细', id }
					return {
						_group: '', minWidth: '95%', list: _list, items: [
							{ _text: '', name: '资产编码', ...p, disabled: true },
							{ _text: '', name: '资产名称', ...p, disabled: true },
							{ _float: '', name: '资产原值', ...p, textAlign: 'left' },
							{ _float: '', name: '资产残值', ...p, textAlign: 'left' },
							{ _date: '', name: '入账日期', ...p, },
							{ _text: '', name: '财务备注', ...p, },
						]
					}
				}))
			},
			{ _files: '异动结果附件', minWidth: '95%', required: true, cdt: () => 状态 == '资产异动' || 状态 == '已完成', disabled: 状态 !== '资产异动' },
		]
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	render() {
		const { showMessage: Message, showBody: Body, readOnly } = this.props
		const { errorMessage, id, initValues基本信息 } = this.state
		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 状态, 提交时间 } = initValues基本信息
		return <Body data={this} maxWidth="100%"
			controls={
				readOnly ? [
					{ _button: '打印', icon: 'print', handler: this.handlerAssetChangePrint, cdt: () => id > 0 && 状态 == '已完成', },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				] :
					[
						{ _flow: 'AssetChangeFlow', disabled: this.bChanged() || !(this.canSave()), cdt: () => id > 0 },
						{ _button: '打印', icon: 'print', handler: this.handlerAssetChangePrint, cdt: () => id > 0 && 状态 == '已完成', },
						{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(this.canSave() && this.bChanged()), cdt: () => 状态 == '申请中' || 状态 == '财务经办签核' || 状态 == '资产异动' },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, handler: this.handlerDelete, disabled: this.bChanged() },
						{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中' },
					{
						_fieldsets: [
							{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
							{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
						], docked: 'right', width: '40%',
					}
				]
			}
		/>
	}
}

export default connect()(AssetChangeDiv)